export class ErrorLogGroupModel {
    constructor(dateString, errorLogs) {
        this.date = new Date(dateString);
        this.dateString = dateString;
        this.errorLogs = errorLogs;
    }
}